import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import TabularReportFilterModel from "../../models/tabular-report-filter";

export default class TabularReportFilterRepository extends BaseRepository {
  static modelClass = TabularReportFilterModel;
  modelName = "tabular-report-filter";

  async query(reportId) {
    return await super.query({
      urlPath: `tabular_reports/${reportId}/filters/`,
    });
  }
}
